import ECharts from "echarts-for-react";

export default function ChartGauge(props) {
    const { min = 0, max = 100, value = 0, enabled = true, format = {} } = props;

    const {
        startAngle = 210,
        endAngle = -30,
        showAxisTick = false,
        showSplitLine = false,
        showAxisLabel = false,
        showDetail = false
    } = format;

    // Deep clone the entire default options to avoid reference sharing between instances
    const defaultGaugeOptionClone = JSON.parse(JSON.stringify(defaultGaugeOption));

    const gaugeOption = {
        series: [
            {
                ...defaultGaugeOptionClone.series[0],
                startAngle,
                endAngle,
                min,
                max,
                axisTick: {
                    show: showAxisTick
                },
                splitLine: {
                    show: showSplitLine
                },
                axisLabel: {
                    show: showAxisLabel
                },
                detail: {
                    show: showDetail
                },
                data: [
                    {
                        value
                    }
                ]
            }
        ]
    };

    if (!enabled) {
        gaugeOption.series[0].axisLine.lineStyle.color = [
            [0.3, "#282828"],
            [0.7, "#414141"],
            [1, "#282828"]
        ];

        gaugeOption.series[0].pointer.itemStyle.color = "#2D2D2D";

        // Use a second series item that is a full pie or gauge filled with dark color placed behind the main gauge.
        gaugeOption.series.unshift({
            type: "gauge",
            startAngle: 0,
            endAngle: 360,
            radius: "100%", // Adjust radius to fit inside the main axisLine
            min: 0,
            max: 1,
            splitNumber: 0,
            axisLine: {
                show: false
            },
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { show: false },
            pointer: { show: false },
            detail: { show: false },
            progress: {
                show: true,
                width: 100, // Large width to fill the center
                itemStyle: {
                    color: "#181818"
                }
            },
            data: [{ value: 1 }],
            silent: true // This disables mouse interactions, removing the pointer cursor
        });
        gaugeOption.animation = false;
        gaugeOption.series[0].radius = "50%"; // Adjust based on visual fit
        gaugeOption.series[1].silent = true;
    }

    return (
        <ECharts
            option={gaugeOption}
            style={{ width: "100%", height: "100%" }}
            notMerge={true}
            lazyUpdate={true}
            key={`gauge-${enabled}`}
        />
    );
}

export const defaultGaugeOption = {
    series: [
        {
            type: "gauge",
            startAngle: 210,
            endAngle: -30,
            min: 0,
            max: 100,
            splitNumber: 10,
            axisLine: {
                lineStyle: {
                    width: 8,
                    color: [
                        [0.3, "#ff3636"],
                        [0.7, "#ff9900"],
                        [1, "#00bb00"]
                    ]
                }
            },
            pointer: {
                width: 2,
                length: "50%",
                itemStyle: {
                    color: "#d1d1d1"
                }
            },
            axisTick: {
                show: false,
                distance: -10,
                length: 5,
                lineStyle: {
                    color: "#fff",
                    width: 1
                }
            },
            splitLine: {
                show: false,
                distance: -12,
                length: 10,
                lineStyle: {
                    color: "#fff",
                    width: 2
                }
            },
            axisLabel: {
                show: false
            },
            detail: {
                show: false,
                valueAnimation: true,
                formatter: "{value}%",
                color: "#d1d1d1",
                fontSize: 16,
                offsetCenter: [0, "70%"]
            },
            data: [
                {
                    value: 40
                }
            ]
        }
    ]
};
